//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PayinEdit from './PayinEdit'

export default {
  name: "PayinItem",
  components: {
    PayinEdit,
  },
  data() {
    return {
      
    };
  },
  props: [ 
    'payment',
    'handleDeletePayment',
    'handleEditPayment',
  ],
  mounted(){
  },
  beforeDestroy() {
  },
  methods: {
    
  }
}
